export const Sixteen = 'g';